export const createItemsList = arr => arr.map(([value, text], i) => ({
  key: value,
  value: value,
  renderElement: text,
  selectedRenderElement: text,
  active: i === 0,
}));